import http from '@/libs/axios'

export function getRoles(params) {
  return http({
    url: `/permission_module/roles/`,
    method: 'get',
    params,
  })
}

export function getModules(id) {
  return http({
    url: `/permission_module/role_permission_list/${id}/`,
    method: 'get',
  })
}

export function getModulesChildren(params) {
  return http({
    url: `/permission_module/role_permission_list/${params.role_id}/`,
    method: 'get',
    params,
  })
}

export function patchRoleObjects(data) {
  return http({
    url: `/permission_module/update_status_role_object/`,
    method: 'post',
    data,
  })
}

export function patchPermissionStatus(data) {
  return http({
    url: `/permission_module/active_or_deactive_draft/`,
    method: 'post',
    data,
  })
}

export function saveOrResetPermissions(data) {
  return http({
    url: `/permission_module/save_or_back/${data.id}/`,
    method: 'post',
    data,
  })
}